"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var react_redux_1 = require("react-redux");

var react_1 = require("react");

var useSetActionPreview = function useSetActionPreview() {
  var dispatch = react_redux_1.useDispatch();
  var setActionPreview = react_1.useCallback(function (option) {
    dispatch(scenario_actions_1.default.setPreviewAction(option));
  }, []);
  var resetActionPreview = react_1.useCallback(function () {
    dispatch(scenario_actions_1.default.setPreviewAction(undefined));
  }, []);
  react_1.useEffect(function () {
    return resetActionPreview;
  });
  return {
    setActionPreview: setActionPreview,
    resetActionPreview: resetActionPreview
  };
};

exports.default = useSetActionPreview;